export default __webpack_public_path__ + "static/media/prizes.d57bf63e.webp";